module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": "25000"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "default"
    },
    on: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Got it")])], 1), _vm._v(" "), _c('md-toolbar', [_c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("Schema Generator")]), _vm._v(" "), _c('a', {
    staticClass: "md-button md-icon-button",
    attrs: {
      "target": "_blank",
      "href": "https://github.com/flipboxstudio/schema-generator"
    }
  }, [_c('md-icon', [_vm._v("favorite")])], 1)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": "",
      "id": "app-container"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('div', {
    staticClass: "fluid"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("JSON")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Put your JSON here")])]), _vm._v(" "), _c('md-card-content', [_c('codemirror', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.json),
      expression: "json"
    }],
    staticClass: "fluid",
    attrs: {
      "options": _vm.json_editor_options
    },
    domProps: {
      "value": (_vm.json)
    },
    on: {
      "input": function($event) {
        _vm.json = $event
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block warn"
  }, [_vm._v("Holly crap! You provide invalid JSON.")]) : _c('span', {
    staticClass: "help-block success"
  }, [_vm._v("Great! Your JSON is valid.")])], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-raised md-copy-button",
    attrs: {
      "data-clipboard-text": _vm.json
    },
    on: {
      "click": _vm.copyJSON
    }
  }, [_vm._v("Copy JSON")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.generateSchema
    }
  }, [_vm._v("Generate Schema")])], 1)], 1)], 1)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('div', {
    staticClass: "fluid"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Schema")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Your schema will generated here")])]), _vm._v(" "), _c('md-card-content', [_c('codemirror', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schema),
      expression: "schema"
    }],
    staticClass: "fluid",
    attrs: {
      "options": _vm.scheme_editor_options
    },
    domProps: {
      "value": (_vm.schema)
    },
    on: {
      "input": function($event) {
        _vm.schema = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Read more about JSON schema "), _c('a', {
    attrs: {
      "href": "http://json-schema.org/"
    }
  }, [_vm._v("here")]), _vm._v(".")])], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.generateJSON
    }
  }, [_vm._v("Generate JSON")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary md-copy-button",
    attrs: {
      "data-clipboard-text": _vm.schema
    },
    on: {
      "click": _vm.copySchema
    }
  }, [_vm._v("Copy schema")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b59235d!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 1371
// module chunks = 2